<script>
import { changePassword } from '../services/userService'

const defaultErrors = {
  newPassword: null,
  confirmPassword: null
}

export default {
  name: 'PasswordResetView',
  data() {
    return {
      passwordForm: {},
      errors: { ...defaultErrors }
    }
  },
  async mounted() {
    this.passwordForm.resetToken = this.$route.params.token
  },
  methods: {
    async updatePassword() {
      try {
        const { newPassword, confirmPassword } = this.passwordForm
        if (newPassword.length === 0) {
          return (this.errors = {
            ...defaultErrors,
            newPassword: 'Please enter your new password.'
          })
        } else if (confirmPassword.length === 0) {
          return (this.errors = {
            ...defaultErrors,
            confirmPassword: 'Please confirm your password.'
          })
        } else if (newPassword !== confirmPassword) {
          return (this.errors = {
            ...defaultErrors,
            confirmPassword: 'Passwords do not match.'
          })
        }

        const userData = await changePassword(this.passwordForm)

        if (userData) {
          this.errors = { ...defaultErrors }
          this.$router.replace({ name: 'LoginView' })
        }
      } catch (error) {
        switch (error.message) {
          case 'GraphQL error: Email does not exist':
            this.errors = {
              email: "We couldn't find an account with this email.",
              password: null
            }
            break
          case 'GraphQL error: Wrong password':
            this.errors = {
              email: null,
              password: 'The email or password you entered is incorrect.'
            }
            break

          default:
            break
        }
      }
    }
  }
}
</script>

<template>
  <div class="container section">
    <div class="columns">
      <div class="column is-offset-3 is-6">
        <div class="illustration">
          <img src="@/assets/img/illustrations/sign-in-2.png" alt="Login" />
        </div>

        <h2 class="title is-3 is-spaced has-text-centered">
          Reset your password
        </h2>

        <div class="subtitle has-text-centered">
          Strong passwords include numbers, letters and punctuation marks.
        </div>

        <b-field
          :type="{ 'is-danger': !!errors.newPassword }"
          :message="errors.newPassword"
          label="New password"
        >
          <b-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="Type your new password"
            password-reveal
          />
        </b-field>

        <b-field
          :type="{ 'is-danger': !!errors.confirmPassword }"
          :message="errors.confirmPassword"
          label="Confirm password"
        >
          <b-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="Type your new password one more time"
            password-reveal
          />
        </b-field>

        <div class="column is-pulled-right">
          <button
            class="button is-rounded is-secondary"
            @click="updatePassword"
          >
            Update password
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.is-vertical-center
  align-items: center
  margin-top: 13vw

.field, button, h1
  margin-bottom: 20px

.illustration
  padding: 50px 0 25px
  text-align: center
  img
    max-height: 200px
</style>
